module.exports = __webpack_public_path__ + "static/img/dr-noha.845e6a9d.jpg";